import { render, staticRenderFns } from "./FormServiceAndRepair.vue?vue&type=template&id=05a74f05"
import script from "./FormServiceAndRepair.vue?vue&type=script&lang=js"
export * from "./FormServiceAndRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports